<template>
  <form-layout class="contract-note-form" :loading="isLoading" @save="saveNote">
    <template #title>
      <h1 class="uppercase">Add Note</h1>
    </template>
    <template #body>
      <bdg-text-area ref="note" name="Note" v-model="formData.text" required />
    </template>
  </form-layout>
</template>

<script>
import BdgTextArea from "../../../forms/fields/BdgTextArea";
import FormLayout from "../../layouts/FormLayout";
import { validateRequiredRefs } from "../../../helpers";

export default {
  name: "ContractNoteForm",
  components: { FormLayout, BdgTextArea },
  props: {
    id: Number,
    contract_id: Number,
    text: String
  },
  data() {
    return {
      formData: {
        id: this.id,
        contract_id: this.contract_id,
        text: this.text
      },
      requiredRefs: ["note"]
    };
  },
  computed: {
    isStoringNote() {
      return this.$store.state.Contracts.Notes.isStoringNote;
    },
    isUpdatingNote() {
      return this.$store.state.Contracts.Notes.isUpdatingNote;
    },
    isLoading() {
      return this.id ? this.isUpdatingNote : this.isStoringNote;
    }
  },
  methods: {
    validate() {
      return validateRequiredRefs(this, true);
    },
    saveNote() {
      if (!this.validate()) {
        return;
      }

      if (this.id) {
        this.$store.dispatch("updateNote", this.formData);
      } else {
        this.$store.dispatch("storeNote", this.formData);
      }
    }
  }
};
</script>

<style scoped></style>
